<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item :label="$t('groupmanage.gname')">
        <el-input :placeholder="$t('groupmanage.placeholder')" v-model="filter.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.assets_code" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button icon="el-icon-plus" type="success" @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80"></el-table-column>
      <el-table-column label="策略名称" prop="name"></el-table-column>
      <el-table-column label="站点" prop="power_site_name"></el-table-column>
      <el-table-column label="台区" prop="power_transformer_name"></el-table-column>
      <el-table-column label="警戒值" prop="level_one">
        <template slot-scope="{ row }"> {{ row.level_one }}% </template>
      </el-table-column>
      <el-table-column label="预警值" prop="level_two">
        <template slot-scope="{ row }"> {{ row.level_two }}% </template>
      </el-table-column>
      <el-table-column label="安全值" prop="level_three">
        <template slot-scope="{ row }"> {{ row.level_three }}% </template>
      </el-table-column>
      <el-table-column label="修改时间" prop="modify_time">
        <template slot-scope="{ row }">
          {{ formatDate(row.modify_time) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('publics.operation')" width="200px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">{{ $t("publics.edit") }}</el-button>
          <el-button type="text" @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增or修改策略 -->
    <el-dialog :visible.sync="visible.editGroup" :title="isUpdate ? $t('groupmanage.editortitle') : $t('groupmanage.appendtitle')" width="1000px">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="120px" :model="form" :rules="formRules" ref="groupForm">
            <el-form-item label="策略名称" prop="name">
              <el-input placeholder="请输入策略名称" v-model="form.name" maxlength="30" show-word-limit />
            </el-form-item>
            <el-form-item label="站点" prop="power_site_id">
              <el-select v-model="form.power_site_id" placeholder="请选择站点" style="width: 100%" clearable filterable @change="handleSiteChange">
                <el-option v-for="item in siteOptions" :key="item.ID" :label="item.name" :value="item.ID"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="台区" prop="power_transformer_id">
              <el-select v-model="form.power_transformer_id" placeholder="请先选择台区" style="width: 100%" clearable filterable :disabled="!form.power_site_id">
                <el-option v-for="item in transformerOptions" :key="item.ID" :label="item.name" :value="item.ID"> </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="警戒值" prop="level_one">
              <el-input placeholder="请输入警戒值" v-model="form.level_one" style="width: 100%">
                <el-button slot="append" icon="el-icon-percentage" style="padding: 0 10px">%</el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="预警值" prop="level_two">
              <el-input placeholder="请输入预警值" v-model="form.level_two" style="width: 100%">
                <el-button slot="append" icon="el-icon-percentage" style="padding: 0 10px">%</el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="安全值" prop="level_three">
              <el-input placeholder="请输入安全值" v-model="form.level_three" style="width: 100%">
                <el-button slot="append" icon="el-icon-percentage" style="padding: 0 10px">%</el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" placeholder="请输入备注" v-model="form.remark" rows="3" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="visible.editGroup = false">{{ $t("groupmanage.cancelbtn") }}</el-button>
        <el-button type="primary" @click="onSubmit">{{ $t("groupmanage.confirmbtn") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import { GetStratealarmparamPageList, AddStratealarmparam, UpdateStratealarmparam, DeleteStratealarmparam } from "@/api/strate-alarm-param-transformer"
import { getPowerTransformerList, getPowerSiteList } from "@/api/dev_archive"
import { mapGetters } from "vuex"

export default {
  name: "GroupManage",
  mixins: [pageMixin],
  data() {
    // 自定义数字验证规则
    const validateNumber = (rule, value, callback) => {
      if (value === "" || value === null || value === undefined) {
        // 允许为空
        callback()
      } else {
        // 检查是否为数字
        const num = Number(value)
        if (isNaN(num)) {
          callback(new Error("必须为数字"))
        } else {
          callback()
        }
      }
    }

    return {
      visible: {
        editGroup: false
      },
      tableData: [],
      form: {
        name: "",
        power_site_id: "",
        power_transformer_id: "",
        level_one: 0,
        level_two: 0,
        level_three: 0,
        remark: ""
      },

      allSites: [], // 所有站点数据
      allTransformers: [], // 所有台区数据
      siteOptions: [], // 站点下拉选项
      transformerOptions: [], // 台区下拉选项（根据站点筛选）
      formRules: {},
      filter: {
        name: "",
        assets_code: ""
      },
      loading: false,
      isUpdate: true,
      id: ""
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.formRules = {
      name: [{ required: true, message: "请输入策略名称", trigger: "blur" }],
      power_site_id: [{ required: true, message: "请选择站点", trigger: "change" }],
      power_transformer_id: [{ required: true, message: "请选择台区", trigger: "change" }],
      level_one: [{ validator: this.validateNumber, trigger: "blur" }],
      level_two: [{ validator: this.validateNumber, trigger: "blur" }],
      level_three: [{ validator: this.validateNumber, trigger: "blur" }]
    }

    this.loadAllOptions().then(() => {
      this.getData()
    })
  },
  methods: {
    // 自定义数字验证方法
    validateNumber(rule, value, callback) {
      if (value === "" || value === null || value === undefined) {
        // 允许为空
        callback()
      } else {
        // 检查是否为数字
        const num = Number(value)
        if (isNaN(num)) {
          callback(new Error("必须为数字"))
        } else {
          callback()
        }
      }
    },

    // 加载所有选项数据
    async loadAllOptions() {
      try {
        // 并行加载所有数据
        const [siteRes, transformerRes] = await Promise.all([getPowerSiteList({ pagesize: 100000 }), getPowerTransformerList({ pagesize: 100000 })])

        if (siteRes && siteRes.data) {
          this.allSites = siteRes.data.filter((item) => !item.del)
          this.siteOptions = this.allSites
        }

        if (transformerRes && transformerRes.data) {
          this.allTransformers = transformerRes.data.filter((item) => !item.del)
        }
      } catch (error) {
        console.error("加载选项数据失败:", error)
        this.$message.error("加载选项数据失败")
      }
    },

    // 站点选择变化事件
    handleSiteChange(value) {
      if (value) {
        const selectedSite = this.allSites.find((item) => item.ID === value)
        if (selectedSite) {
          this.transformerOptions_sel = this.transformerOptions.filter((a) => a.power_site_id == value)
          console.log("站点名称:", selectedSite.name)
        }

        // 清空台区选项
        this.form.power_transformer_id = ""
        this.transformerOptions = []

        // 筛选对应站点的台区选项
        this.transformerOptions = this.allTransformers.filter((item) => item.power_site_id === value && !item.del)
      } else {
        // 清空所有相关选项
        this.form.power_transformer_id = ""
        this.transformerOptions = []
      }
    },

    // 获取站点名称
    getSiteName(siteId) {
      const site = this.allSites.find((item) => item.ID === siteId)
      return site ? site.name : siteId
    },

    // 获取台区名称
    getTransformerName(transformerId) {
      const transformer = this.allTransformers.find((item) => item.ID === transformerId)
      return transformer ? transformer.name : transformerId
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return ""
      const date = new Date(dateString)
      return date
        .toLocaleString("zh-CN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false
        })
        .replace(/\//g, "-")
    },

    async onUpdate(row) {
      this.visible.editGroup = true
      this.isUpdate = true

      if (!this.allSites.length || !this.allTransformers.length) {
        await this.loadAllOptions()
      }

      // 重置表单
      this.form = {
        name: row.name || "",
        power_site_id: row.power_site_id || "",
        power_transformer_id: "",
        level_one: row.level_one || 0,
        level_two: row.level_two || 0,
        level_three: row.level_three || 0,
        remark: row.remark || ""
      }
      this.id = row.ID

      // 如果有站点ID，筛选对应的台区
      if (row.power_site_id) {
        this.handleSiteChange(row.power_site_id)

        // 设置台区ID
        this.form.power_transformer_id = row.power_transformer_id || ""
      }
    },

    onDelete(row) {
      this.$confirm("确定要删除该策略吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          DeleteStratealarmparam(row).then((res) => {
            this.$message.success("删除成功")
            this.toFilter()
          })
        })
        .catch(() => {
          // 取消删除
        })
    },

    getData() {
      this.loading = true
      GetStratealarmparamPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        name: this.filter.name || null,
        assets_code: this.filter.assets_code || null
      })
        .then((res) => {
          this.tableData = res.data.map((item) => {
            return {
              ...item,
              power_site_name: this.getSiteName(item.power_site_id),
              power_transformer_name: this.getTransformerName(item.power_transformer_id)
            }
          })
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },

    async onAdd() {
      this.visible.editGroup = true
      this.isUpdate = false
      this.form = this.$options.data().form
      this.id = ""

      if (!this.allSites.length || !this.allTransformers.length) {
        await this.loadAllOptions()
      }

      // 清空台区选项
      this.transformerOptions = []
    },

    onSubmit() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()

          // 将数值字段转换为数字类型
          const reqData = {
            name: this.form.name,
            power_site_id: this.form.power_site_id,
            power_transformer_id: this.form.power_transformer_id,
            level_one: this.form.level_one !== "" ? Number(this.form.level_one) : 0,
            level_two: this.form.level_two !== "" ? Number(this.form.level_two) : 0,
            level_three: this.form.level_three !== "" ? Number(this.form.level_three) : 0,
            remark: this.form.remark
          }

          console.log("提交的数据:", reqData)

          if (this.isUpdate) {
            reqData.ID = this.id
            UpdateStratealarmparam(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.modifiedsuccessful")}`)
                this.visible.editGroup = false
                this.getData()
              })
              .finally(() => {
                loading.close()
              })
          } else {
            AddStratealarmparam(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.addedsuccessful")}`)
                this.visible.editGroup = false
                this.getData()
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
</style>
